import {PermissionsType, SpatialAreaAcceptType} from "./security/model";

export interface FileUploadStatus {
  success: boolean;
  message: string;
  fileName: string;
}

export interface DirectoryItem {
  fileName: string;
  absolutePath: string;
  directory: boolean;
  fileSize: number;
}

export interface Identifiable {
  id: string;
}

export enum EntityType {
  TYPE_DATA,
  TYPE_STYLE,
  TYPE_PRODUCT,
  TYPE_SERVICE,
  TYPE_FILE_INFO,
}

export interface MetadataModel {
  title: string;
  abstractText?: string;
  keywords?: string[];
}

export interface EntityModel extends Identifiable, MetadataModel {
  name?: string;
  sequenceNumber?: number;
}

export interface SpatialModel extends EntityModel {
  wgs84Bounds?: Bounds;
  type?: string;
}

export interface Bounds {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface ConfigurationInfo {
  securityInfo: {
    isMappEnterprise: boolean;
    mappEnterpriseSecurityInfo: {
      authServiceUrl: string;
      clientId: string;
    };
  };
  missingMappEnterpriseInfo: boolean;
  invalidMappEnterpriseInfo: boolean;
}

export interface AccessRule {
  id?: string;
  role: string;
  permissions: PermissionsType[];
  scaleRange?: ScaleRange,
  spatialRange?: SpatialRange
}

export interface ScaleRange {
  minScaleDenominator: number;
  maxScaleDenominator: number;
}

export interface SpatialRange {
  area: string,
  spatialReference: string,
  accept: SpatialAreaAcceptType,
  overlappingShapes: string
}

export interface OidcProviderInfo {
  clientId: string;
  authorizationEndpoint: string;
  tokenEndpoint: string;
  logoutEndpoint: string;
  redirectUri: string;
  scope: string;
  jwkSetEndpoint: string;
  userInfoEndpoint: string;
  issuer: string;
  enabled: boolean;
}